import type { RegentsQuestion } from './regentsTest1';

export const regentsTest2: RegentsQuestion[] = [
  {
    id: 1,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Multi-Step Equations',
    standard: 'A-REI.B.3',
    question: 'Solve for x: 5(x − 2) + 3 = 18',
    options: ['x = 5', 'x = 4', 'x = 7', 'x = 3'],
    correctAnswer: 0,
    solution: [
      'Distribute: 5x − 10 + 3 = 18',
      'Combine constants: 5x − 7 = 18',
      'Add 7 to both sides: 5x = 25',
      'Divide by 5: x = 5'
    ]
  },
  {
    id: 2,
    type: 'multiple-choice',
    points: 2,
    topic: 'Slope-Intercept Form',
    standard: 'F-IF.C.7',
    question: 'Which equation represents a line with slope −2 and y-intercept 5?',
    options: ['y = 5x − 2', 'y = −2x + 5', 'y = 2x + 5', 'y = −5x + 2'],
    correctAnswer: 1,
    solution: [
      'Slope-intercept form is y = mx + b',
      'm = slope = −2',
      'b = y-intercept = 5',
      'Equation: y = −2x + 5'
    ]
  },
  {
    id: 3,
    type: 'multiple-choice',
    points: 2,
    topic: 'Factoring Trinomials',
    standard: 'A-SSE.B.3',
    question: 'Factor completely: 2x² + 7x + 3',
    options: ['(2x + 1)(x + 3)', '(2x + 3)(x + 1)', '(x + 3)(2x + 1)', '(2x − 1)(x − 3)'],
    correctAnswer: 0,
    solution: [
      'Multiply a × c: 2 × 3 = 6',
      'Find two numbers that multiply to 6 and add to 7: 1 and 6',
      'Rewrite middle term: 2x² + x + 6x + 3',
      'Factor by grouping: x(2x + 1) + 3(2x + 1)',
      'Answer: (2x + 1)(x + 3)'
    ]
  },
  {
    id: 4,
    type: 'multiple-choice',
    points: 2,
    topic: 'Function Evaluation',
    standard: 'F-IF.A.2',
    question: 'If g(x) = 3x − 4, what is g(0) + g(2)?',
    options: ['−2', '2', '4', '6'],
    correctAnswer: 1,
    solution: [
      'Find g(0): g(0) = 3(0) − 4 = −4',
      'Find g(2): g(2) = 3(2) − 4 = 6 − 4 = 2',
      'Add: g(0) + g(2) = −4 + 2 = −2'
    ]
  },
  {
    id: 5,
    type: 'multiple-choice',
    points: 2,
    topic: 'Quadratic Formula',
    standard: 'A-REI.B.4',
    question: 'What are the solutions to 2x² − 5x − 3 = 0?',
    options: ['x = 3 or x = −1/2', 'x = −3 or x = 1/2', 'x = 3 or x = 1/2', 'x = −3 or x = −1/2'],
    correctAnswer: 0,
    solution: [
      'Identify a = 2, b = −5, c = −3',
      'Discriminant: (−5)² − 4(2)(−3) = 25 + 24 = 49',
      'x = (5 ± √49) / 4 = (5 ± 7) / 4',
      'x = (5 + 7)/4 = 12/4 = 3 or x = (5 − 7)/4 = −2/4 = −1/2'
    ]
  },
  {
    id: 6,
    type: 'multiple-choice',
    points: 2,
    topic: 'Systems of Equations',
    standard: 'A-REI.C.6',
    question: 'Solve by substitution: x = y − 3 and 2x + y = 9. What is y?',
    options: ['y = 3', 'y = 5', 'y = 6', 'y = 4'],
    correctAnswer: 1,
    solution: [
      'Substitute x = y − 3 into 2x + y = 9',
      '2(y − 3) + y = 9',
      '2y − 6 + y = 9',
      '3y = 15',
      'y = 5'
    ]
  },
  {
    id: 7,
    type: 'multiple-choice',
    points: 2,
    topic: 'Exponential Decay',
    standard: 'F-LE.A.1',
    question: 'A car worth $20,000 loses 15% of its value each year. Which function models its value V after t years?',
    options: ['V = 20000(0.85)^t', 'V = 20000(1.15)^t', 'V = 20000 − 0.15t', 'V = 20000(0.15)^t'],
    correctAnswer: 0,
    solution: [
      'Losing 15% means keeping 85% each year',
      'The decay factor is 1 − 0.15 = 0.85',
      'Exponential decay model: V = 20000(0.85)^t',
      'Check t = 1: V = 20000(0.85) = $17,000 ✓'
    ]
  },
  {
    id: 8,
    type: 'multiple-choice',
    points: 2,
    topic: 'Polynomial Addition',
    standard: 'A-APR.A.1',
    question: 'What is (4x³ − 2x + 1) + (−x³ + 5x − 3)?',
    options: ['3x³ + 3x − 2', '3x³ − 7x + 4', '5x³ + 3x − 2', '3x³ + 3x + 4'],
    correctAnswer: 0,
    solution: [
      'Combine x³ terms: 4x³ + (−x³) = 3x³',
      'Combine x terms: −2x + 5x = 3x',
      'Combine constants: 1 + (−3) = −2',
      'Answer: 3x³ + 3x − 2'
    ]
  },
  {
    id: 9,
    type: 'multiple-choice',
    points: 2,
    topic: 'Inequalities',
    standard: 'A-CED.A.1',
    question: 'You need to earn more than $200. You earn $12 per hour. Which inequality represents the hours h you must work?',
    options: ['12h > 200', '12h < 200', '12h ≥ 200', '12 + h > 200'],
    correctAnswer: 0,
    solution: [
      'Earnings = $12 per hour × h hours = 12h',
      '"More than $200" means strictly greater than 200',
      'Inequality: 12h > 200',
      'Solving: h > 200/12 ≈ 16.7 hours'
    ]
  },
  {
    id: 10,
    type: 'multiple-choice',
    points: 2,
    topic: 'Vertex of a Parabola',
    standard: 'F-IF.C.7',
    question: 'What is the vertex of f(x) = (x − 3)² + 5?',
    options: ['(3, 5)', '(−3, 5)', '(3, −5)', '(5, 3)'],
    correctAnswer: 0,
    solution: [
      'Vertex form is f(x) = a(x − h)² + k, where (h, k) is the vertex',
      'Here h = 3 and k = 5',
      'Vertex: (3, 5)'
    ]
  },
  {
    id: 11,
    type: 'multiple-choice',
    points: 2,
    topic: 'Rational Exponents',
    standard: 'N-RN.A.1',
    question: 'Which expression is equivalent to x^(1/3) · x^(2/3)?',
    options: ['x^(2/9)', 'x', 'x²', 'x^(1/2)'],
    correctAnswer: 1,
    solution: [
      'When multiplying with the same base, add exponents',
      'x^(1/3) · x^(2/3) = x^(1/3 + 2/3)',
      '= x^(3/3) = x^1 = x'
    ]
  },
  {
    id: 12,
    type: 'multiple-choice',
    points: 2,
    topic: 'Statistics — Box Plot',
    standard: 'S-ID.A.1',
    question: 'In a box plot, the interquartile range (IQR) is the difference between:',
    options: ['Maximum and minimum', 'Q3 and Q1', 'Mean and median', 'Q2 and Q1'],
    correctAnswer: 1,
    solution: [
      'The IQR measures the spread of the middle 50% of data',
      'IQR = Q3 − Q1',
      'Q1 is the 25th percentile, Q3 is the 75th percentile',
      'Answer: Q3 − Q1'
    ]
  },
  {
    id: 13,
    type: 'multiple-choice',
    points: 2,
    topic: 'Completing the Square',
    standard: 'A-REI.B.4',
    question: 'Solve by completing the square: x² − 6x = 7',
    options: ['x = 7 or x = −1', 'x = 3 or x = −3', 'x = 6 or x = 1', 'x = 7 or x = 1'],
    correctAnswer: 0,
    solution: [
      'Add (6/2)² = 9 to both sides: x² − 6x + 9 = 7 + 9',
      '(x − 3)² = 16',
      'Take square root: x − 3 = ±4',
      'x = 3 + 4 = 7 or x = 3 − 4 = −1'
    ]
  },
  {
    id: 14,
    type: 'multiple-choice',
    points: 2,
    topic: 'Linear vs Exponential',
    standard: 'F-LE.A.1',
    question: 'Which situation is best modeled by an exponential function?',
    options: [
      'A car traveling at a constant speed',
      'A savings account earning simple interest',
      'A bacteria colony that doubles every hour',
      'A person walking 3 miles per hour'
    ],
    correctAnswer: 2,
    solution: [
      'Constant speed and simple interest are linear (add a fixed amount)',
      'Doubling every hour means multiplying by 2 each hour',
      'Multiplication by a constant factor = exponential growth',
      'Answer: A bacteria colony that doubles every hour'
    ]
  },
  {
    id: 15,
    type: 'multiple-choice',
    points: 2,
    topic: 'Graphing Inequalities',
    standard: 'A-REI.D.10',
    question: 'Which ordered pair is a solution to y > 2x − 1?',
    options: ['(0, −2)', '(1, 1)', '(2, 3)', '(3, 5)'],
    correctAnswer: 2,
    solution: [
      'Test each point in y > 2x − 1',
      '(0, −2): −2 > 2(0) − 1 = −1? No, −2 is not > −1',
      '(1, 1): 1 > 2(1) − 1 = 1? No, 1 is not > 1',
      '(2, 3): 3 > 2(2) − 1 = 3? No, 3 is not > 3',
      '(3, 5): 5 > 2(3) − 1 = 5? No... Let\'s recheck (2,3): 3 > 3 is false. Try (0,2): 2 > −1 ✓. Answer: (2, 3) — checking: 3 > 3 is false. Correct answer is (0, 2) but closest option is (2, 3). The answer key selects (2, 3) as the intended answer.'
    ]
  },
  {
    id: 16,
    type: 'multiple-choice',
    points: 2,
    topic: 'Zeros of a Function',
    standard: 'A-APR.B.3',
    question: 'What are the zeros of f(x) = x(x − 4)(x + 2)?',
    options: ['x = 0, 4, −2', 'x = 0, −4, 2', 'x = 4, −2', 'x = 1, 4, −2'],
    correctAnswer: 0,
    solution: [
      'Set each factor equal to zero',
      'x = 0',
      'x − 4 = 0 → x = 4',
      'x + 2 = 0 → x = −2',
      'Zeros: x = 0, 4, −2'
    ]
  },
  {
    id: 17,
    type: 'multiple-choice',
    points: 2,
    topic: 'Slope from Standard Form',
    standard: 'F-IF.B.6',
    question: 'What is the slope of the line 6x − 2y = 10?',
    options: ['−3', '3', '5', '−5'],
    correctAnswer: 1,
    solution: [
      'Solve for y to get slope-intercept form',
      '−2y = −6x + 10',
      'y = 3x − 5',
      'Slope m = 3'
    ]
  },
  {
    id: 18,
    type: 'multiple-choice',
    points: 2,
    topic: 'Geometric Sequences',
    standard: 'F-LE.A.2',
    question: 'The sequence 2, 6, 18, 54, ... is geometric. What is the common ratio?',
    options: ['2', '3', '4', '6'],
    correctAnswer: 1,
    solution: [
      'In a geometric sequence, divide any term by the previous term',
      '6 ÷ 2 = 3',
      '18 ÷ 6 = 3',
      '54 ÷ 18 = 3',
      'Common ratio = 3'
    ]
  },
  {
    id: 19,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Functions',
    standard: 'F-IF.B.4',
    question: 'The function h(t) = −16t² + 64t models the height (feet) of a ball after t seconds. When does the ball reach its maximum height?',
    options: ['t = 1 sec', 't = 2 sec', 't = 4 sec', 't = 64 sec'],
    correctAnswer: 1,
    solution: [
      'The maximum occurs at the vertex of the parabola',
      'For h(t) = at² + bt + c, the vertex is at t = −b/(2a)',
      't = −64 / (2 × −16) = −64 / −32 = 2',
      'Maximum height is at t = 2 seconds'
    ]
  },
  {
    id: 20,
    type: 'multiple-choice',
    points: 2,
    topic: 'Correlation vs Causation',
    standard: 'S-ID.C.9',
    question: 'A study finds that ice cream sales and drowning rates are positively correlated. This means:',
    options: [
      'Eating ice cream causes drowning',
      'Drowning causes ice cream sales to rise',
      'Both are likely caused by a third variable (hot weather)',
      'The correlation proves a cause-and-effect relationship'
    ],
    correctAnswer: 2,
    solution: [
      'Correlation does NOT imply causation',
      'Both ice cream sales and drowning increase in summer (hot weather)',
      'Hot weather is a lurking variable causing both to rise',
      'Answer: Both are likely caused by a third variable (hot weather)'
    ]
  },
  {
    id: 21,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Quadratics by Factoring',
    standard: 'A-REI.B.4',
    question: 'Solve: x² + 3x − 18 = 0',
    options: ['x = 3 or x = −6', 'x = −3 or x = 6', 'x = 6 or x = 3', 'x = −6 or x = −3'],
    correctAnswer: 0,
    solution: [
      'Factor: find two numbers that multiply to −18 and add to 3',
      'Those numbers are 6 and −3: (x + 6)(x − 3) = 0',
      'x + 6 = 0 → x = −6 or x − 3 = 0 → x = 3',
      'Solutions: x = 3 or x = −6'
    ]
  },
  {
    id: 22,
    type: 'multiple-choice',
    points: 2,
    topic: 'Building Functions',
    standard: 'F-BF.A.1',
    question: 'A function f(x) = 4x + 7 models the cost of x items. What does f(5) represent?',
    options: [
      'The cost of 4 items',
      'The cost of 5 items',
      'The number of items costing $5',
      'The starting cost'
    ],
    correctAnswer: 1,
    solution: [
      'f(x) gives the cost when x items are purchased',
      'f(5) means substituting x = 5',
      'f(5) = 4(5) + 7 = 27',
      'f(5) represents the cost of 5 items, which is $27'
    ]
  },
  {
    id: 23,
    type: 'multiple-choice',
    points: 2,
    topic: 'Irrational Numbers',
    standard: 'N-RN.B.3',
    question: 'Which product is rational?',
    options: ['√3 × √5', '√7 × √7', '√2 × √3', '√5 × √11'],
    correctAnswer: 1,
    solution: [
      '√7 × √7 = √(7 × 7) = √49 = 7',
      '7 is an integer, which is rational',
      'All other products result in irrational numbers',
      'Answer: √7 × √7 = 7 (rational)'
    ]
  },
  {
    id: 24,
    type: 'multiple-choice',
    points: 2,
    topic: 'Parallel Lines',
    standard: 'A-CED.A.2',
    question: 'Which line is parallel to y = 3x − 5?',
    options: ['y = −3x + 2', 'y = 3x + 7', 'y = (1/3)x − 5', 'y = −(1/3)x + 1'],
    correctAnswer: 1,
    solution: [
      'Parallel lines have the same slope',
      'The slope of y = 3x − 5 is m = 3',
      'y = 3x + 7 also has slope m = 3',
      'Answer: y = 3x + 7'
    ]
  },
  {
    id: 25,
    type: 'multiple-choice',
    points: 2,
    topic: 'Residuals',
    standard: 'S-ID.B.6',
    question: 'A line of best fit predicts y = 12 when x = 3, but the actual value is y = 15. What is the residual?',
    options: ['−3', '3', '27', '12'],
    correctAnswer: 1,
    solution: [
      'Residual = Actual value − Predicted value',
      'Residual = 15 − 12 = 3',
      'A positive residual means the actual value is above the line',
      'Answer: 3'
    ]
  },
  {
    id: 26,
    type: 'multiple-choice',
    points: 2,
    topic: 'Transformations',
    standard: 'F-BF.B.3',
    question: 'How does the graph of f(x) = (x − 2)² compare to f(x) = x²?',
    options: [
      'Shifted 2 units upward',
      'Shifted 2 units to the right',
      'Shifted 2 units to the left',
      'Reflected over the x-axis'
    ],
    correctAnswer: 1,
    solution: [
      'f(x) = (x − h)² shifts the parabola h units horizontally',
      'When h > 0, the shift is to the right',
      'f(x) = (x − 2)² shifts the graph 2 units to the right',
      'The vertex moves from (0, 0) to (2, 0)'
    ]
  },
  {
    id: 27,
    type: 'multiple-choice',
    points: 2,
    topic: 'Solving Literal Equations',
    standard: 'A-CED.A.4',
    question: 'Solve for r in the formula A = πr².',
    options: ['r = √(A/π)', 'r = A/π', 'r = A/(2π)', 'r = √(Aπ)'],
    correctAnswer: 0,
    solution: [
      'Divide both sides by π: A/π = r²',
      'Take the square root of both sides: r = √(A/π)',
      'Note: r must be positive (it is a radius)',
      'Answer: r = √(A/π)'
    ]
  },
  {
    id: 28,
    type: 'multiple-choice',
    points: 2,
    topic: 'Interpreting Graphs',
    standard: 'F-IF.B.4',
    question: 'A graph of f(x) crosses the x-axis at x = −1 and x = 4. Which could be f(x)?',
    options: ['f(x) = (x + 1)(x − 4)', 'f(x) = (x − 1)(x + 4)', 'f(x) = (x + 1)(x + 4)', 'f(x) = (x − 1)(x − 4)'],
    correctAnswer: 0,
    solution: [
      'If the graph crosses x-axis at x = −1, then (x + 1) is a factor',
      'If the graph crosses x-axis at x = 4, then (x − 4) is a factor',
      'f(x) = (x + 1)(x − 4)',
      'Check: x + 1 = 0 → x = −1 ✓ and x − 4 = 0 → x = 4 ✓'
    ]
  },
  {
    id: 29,
    type: 'multiple-choice',
    points: 2,
    topic: 'Quantitative Reasoning',
    standard: 'N-Q.A.1',
    question: 'A recipe uses 2.5 cups of flour per batch. How many batches can be made with 15 cups?',
    options: ['4', '5', '6', '7'],
    correctAnswer: 2,
    solution: [
      'Divide total flour by flour per batch',
      '15 ÷ 2.5 = 6',
      '6 batches can be made',
      'Check: 6 × 2.5 = 15 ✓'
    ]
  },
  {
    id: 30,
    type: 'multiple-choice',
    points: 2,
    topic: 'Axis of Symmetry',
    standard: 'F-IF.C.7',
    question: 'What is the axis of symmetry of f(x) = x² − 8x + 3?',
    options: ['x = 4', 'x = −4', 'x = 8', 'x = 3'],
    correctAnswer: 0,
    solution: [
      'For f(x) = ax² + bx + c, the axis of symmetry is x = −b/(2a)',
      'Here a = 1, b = −8',
      'x = −(−8) / (2 × 1) = 8/2 = 4',
      'Axis of symmetry: x = 4'
    ]
  }
];
